import { Modal } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Modal as NBModal, ScrollView } from 'native-base';
import { Dimensions } from 'react-native';

import { useRecoilQuery } from '../../../../../../../../../hooks/useRecoilQuery';
import { privatePensionDetailsQuery } from '../../../../../../../../../store/product/selectors';
import { usePrivatePensionAssetContext } from '../../../../../contexts/products/PrivatePension';

import { PrivatePensionDetailsContent } from './components/PrivatePensionDetailsContent';
import { PrivatePensionDetailsDocuments } from './components/PrivatePensionDetailsDocuments';
import { PrivatePensionDetailsHeader } from './components/PrivatePensionDetailsHeader';

export const ItemDetails = () => {
  const { height } = Dimensions.get('window');

  const { modalOpen, offerSelected, setModalOpen } = usePrivatePensionAssetContext();

  const { data, loading, error } = useRecoilQuery(
    privatePensionDetailsQuery({
      cpnj: offerSelected?.productDocument,
    })
  );

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  if (!offerSelected) {
    return <></>;
  }

  const props = {
    offer: offerSelected,
    onClose: handleCloseModal,
    details: data,
    loading,
    error,
  };

  return (
    <Modal isOpen={modalOpen} onClose={handleCloseModal} testId="modal-details">
      <NBModal.Content
        alignItems="center"
        w="full"
        bgColor="neutral.white"
        maxH={{ base: height * 0.75, lg: '80vh' }}
        maxW={{ base: 'full', lg: '909px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}
        padding={{ base: 'inset.xs', lg: 'inset.md' }}
        borderRadius={BoxBorder.heavy}>
        <ScrollView w="full" showsVerticalScrollIndicator={false}>
          <PrivatePensionDetailsHeader {...props} />
          <PrivatePensionDetailsContent {...props} />
          <PrivatePensionDetailsDocuments {...props} />
        </ScrollView>
      </NBModal.Content>
    </Modal>
  );
};
